import { Button, TableCell } from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const FinancialDataHeaderCell = ({
  cellName,
  orderBy,
  orderDirection,
  onTableHeadSort,
  width,
  textAlign,
}) => {
  const isSorted = orderBy === cellName
  const SortIcon =
    orderDirection === 'ASC' ? ArrowDownwardIcon : ArrowUpwardIcon

  return (
    <TableCell
      style={{
        width: width,
        color: 'black',
        padding: '0px 0px 0px 10px',
        borderBottom: 'none',
        justifyContent: textAlign,
        textAlign: textAlign,
      }}
    >
      <Button
        style={{
          color: 'white',
          fontWeight: isSorted ? 'bold' : 'normal',
          fontSize: '20px',
        }}
        onClick={onTableHeadSort ? () => onTableHeadSort(cellName) : undefined}
        disabled={!onTableHeadSort} // If sorting function is not provided, disable the sorting button
      >
        {cellName}
        {isSorted && <SortIcon fontSize="small" />}
      </Button>
    </TableCell>
  )
}

export default FinancialDataHeaderCell
